import { Store } from 'redux';
import { TRouter } from './types';
import { Location } from 'history';

// Create router reducer that mimics connected-react-router behavior
export function connectRouter(router: TRouter): (state: RouterState | undefined, action: any) => RouterState {
  return (
    state: RouterState | undefined = { location: router.state.location, action: 'POP' },
    action: any
  ): RouterState => {
    if (action.type === LOCATION_CHANGE) {
      return {
        location: action.payload.location,
        action: action.payload.action
      };
    }
    return state;
  };
}

// Create router middleware that dispatches LOCATION_CHANGE actions
export function createRouterMiddleware(router: TRouter) {
  return (store: Store<any>) => {
    router.subscribe((state) => {
      store.dispatch({
        type: LOCATION_CHANGE,
        payload: {
          location: state.location,
          action: state.historyAction,
          isFirstRendering: false
        }
      });
    });

    setTimeout(() => {
      store.dispatch({
        type: LOCATION_CHANGE,
        payload: {
          location: router.state.location,
          action: 'POP',
          isFirstRendering: true
        }
      });
    }, 0);

    return (next: any) => (action: any) => {
      return next(action);
    };
  };
} // Action type constant

export const LOCATION_CHANGE = 'LOCATION_CHANGE';
// Action creator interface

export interface LocationChangeAction<P = any> {
  type: typeof LOCATION_CHANGE;
  payload: {
    location: Location;
    action: 'PUSH' | 'POP' | 'REPLACE';
    isFirstRendering?: boolean;
  };
}
export type { LocationChangeAction as TLocationChangeAction };
// Router state interface

export interface RouterState {
  location: Location;
  action: 'PUSH' | 'POP' | 'REPLACE';
}
